export default __webpack_public_path__ + "static/l2-hero-image---0e4db7a182c0e433c6cc47bb1742dc88.svg";